@if(!componentWithDataSetter?.component && (dropdownOptions?.length || isField) && !forceHide){
<div
  #dropdownContainer
  class="tw-shadow-lg dropdown-list-container tw-rounded-lg tw-max-h-screen tw-overflow-auto tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-bg-white dark:tw-bg-gray-800"
  [ngClass]="{ 'tw-p-3': isField }"
  [style.width]="widthInPX"
  [style.minWidth]="minWidthInPX"
  [style.height.px]="heightInPX > 0 ? heightInPX : null"
  [class.tw-h-fit]="!heightInPX"
  [style.maxHeight.px]="maxHeightInPX"
  [ngClass]="{ 'field-dropdown': isField }"
  tabindex="0"
  (focus)="resetFocusIndex()"
  (blur)="resetFocusIndex()"
>
  @for (option of dropdownOptions; track $index) {
  <button
    type="button"
    [attr.disabled]="option.disabled && isSingleSelect ? true : null"
    (click)="onOptionClicked($index)"
    [ngClass]="{
      'tw-border-b tw-border-gray-200 dark:tw-border-gray-400': $index !== (dropdownOptions?.length ?? 0) - 1 && !isField,
      'tw-cursor-initial': option.disabled,
      'tw-cursor-not-allowed': option.disabled && isSingleSelect,
      'tw-cursor-pointer': !option.disabled,
      'tw-opacity-50': option.disabled,
      'tw-bg-gray-50 dark:tw-bg-gray-700': focusedIndex === $index
    }"
    class="dropdown-option {{
      isField ? 'field-option' : 'default-option'
    }} tw-border-b tw-border-gray-200 dark:tw-border-gray-700 hover:!tw-bg-gray-50 dark:hover:!tw-bg-gray-700 focus:!tw-bg-gray-50 dark:focus:!tw-bg-gray-700 dark:tw-bg-gray-800 tw-box-border tw-items-center tw-justify-between tw-w-full tw-flex focus:tw-outline-none"
    tabindex="-1"
    role="option"
    [attr.aria-selected]="focusedIndex === $index"
    [style.marginBottom.px]="optionGapInPX > 0 && $index !== (dropdownOptions?.length ?? 0) - 1 ? optionGapInPX : null"
  >
    <div class="tw-rounded-xl option tw-flex tw-gap-3 tw-items-center tw-w-full" [ngClass]="{ 'tw-items-start': !!option.data?.optionComponent }">
      @if(option.prefixIcon){
      <span class="prefix-icon" [innerHTML]="option.prefixIcon | safe"></span>
      }
      @if (option.data?.optionComponent) {
      <ng-container
        [ngComponentOutlet]="option.data.optionComponent"
        [ngComponentOutletInputs]="option.data.inputs ?? {}"
      />
      } @else {
      <span
        [ngClass]="{ 'tw-text-gray-400 dark:tw-text-gray-500': option.disabled }"
        [class]="option?.textColorClass"
        class="tw-text-sm tw-text-start tw-font-inter tw-truncate"
        [attr.title]="isField ? option.value : null"
        [innerHTML]="option.value | safe"
      ></span>
      }
    </div>
    @if(option?.suffixText){
    <span class="tw-font-medium tw-font-inter tw-text-xs tw-leading-4 tw-text-blue-700 tw-text-nowrap">{{ option.suffixText }}</span>
    } @if(option?.suffixHTML){
    <div [innerHTML]="option.suffixHTML | safe"></div>
    }
  </button>
  } @if(!dropdownOptions?.length){
  <div class="tw-w-full tw-text-center tw-font-medium tw-font-inter tw-text-sm tw-leading-[21px] tw-py-2 tw-text-gray-300 tw-select-none">
    {{ optionNoData || 'v2.fields.dropdown' | translate }}
  </div>
  }
</div>
}
<div
  [style.width]="widthInPX"
  [style.minWidth]="minWidthInPX"
  [style.maxHeight.px]="containerMaxHeight! + 5"
  [ngClass]="{ 'tw-hidden': displayCustomComponent }"
  class="dropdown-list-container tw-shadow-lg tw-max-h-screen tw-overflow-auto tw-border tw-rounded-lg"
>
  <ng-template #dynamicTarget></ng-template>
</div>
